import { useActiveCompanyUser } from 'src/organization/hooks/useActiveCompanyUser';

export const AdminGuard = ({ element }: { element: JSX.Element }) => {
  const { activeCompanyUser } = useActiveCompanyUser();
  if (activeCompanyUser?.role === 'administrator') {
    return <div className="admin">{element}</div>;
  }
  return null;
};
